import React from 'react';

import { GoalsIcon } from '@atlaskit/logo';

import { Products } from '../../constants';
import type { FallbackUrl, GlobalShortcutConfiguration } from '../../types';
import { useAppGlobalShortcutLinkItem } from '../../utils/use-app-global-shortcut-link-item';

import { messages } from './messages';

const icon = <GoalsIcon size="xsmall" shouldUseNewLogoDesign label="" />;

export const useGoals = (fallbackUrl: FallbackUrl, options: GlobalShortcutConfiguration = {}) =>
	useAppGlobalShortcutLinkItem(icon, messages.label, fallbackUrl, {
		apsKey: Products.ATLAS_GOALS,
		analyticsName: Products.ATLAS_GOALS,
		...options,
	});
